import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { Button, Checkbox } from '@components';
import { DataItem } from '@common/interfaces';
import css from './styles.module.scss';

interface ITableFilterItem {
  label: string;
  value: string;
}

interface ITableFilter {
  items?: ITableFilterItem[];
  selectedItems: DataItem[];
  onChange: Dispatch<SetStateAction<DataItem[]>>;
}

const TableFilter: FC<ITableFilter> = ({ items = [], onChange, selectedItems }) => {
  const [innerSelectedItems, setInnerSelectedItems] = useState<DataItem[]>(selectedItems);
  const [filteredItems, setFilteredItems] = useState(items);

  useEffect(() => {
    setFilteredItems(items);
  }, [items.length]);

  useEffect(() => {
    setInnerSelectedItems(selectedItems);
  }, [selectedItems.length]);

  return (
    <div className={css.dropdownBox}>
      <div className={css.content}>
        {filteredItems.length === 0 ? <div className={css.empty}>No items</div> : null}
        {filteredItems.map((item) => {
          const { label, value } = item;
          return (
            <Checkbox
              key={value}
              checked={Boolean(innerSelectedItems.find((elem) => elem.value === value))}
              onChange={(checked) => {
                if (checked) {
                  setInnerSelectedItems((prevArray) => [...prevArray, { label, value }]);
                } else {
                  setInnerSelectedItems((prevArray) => [...prevArray].filter((elem) => elem.value !== value));
                }
              }}
              label={label}
            />
          );
        })}
      </div>
      <Button
        className={css.applyButton}
        text='Apply'
        onClick={() => {
          onChange(innerSelectedItems);
        }}
      />
    </div>
  );
};

export default TableFilter;
